/**
 * Deep readonly type. Currently only handles arrays, objects, and primitives (not sets or maps).
 */
export type DeepReadonly<T> = T extends (infer U)[]
  ? ReadonlyArray<DeepReadonly<U>>
  : T extends object
    ? { readonly [K in keyof T]: DeepReadonly<T[K]> }
    : T;

/**
 * Deep `Object.freeze()` a JSON-like object in place.
 * Returns the original object (now frozen) for convenience and typing.
 *
 * (This can be moved to a common location if anything else needs it in the future.)
 */
export function deepFreeze<T>(obj: T): DeepReadonly<T> {
  if (obj && typeof obj === 'object') {
    for (const value of Object.values(obj)) {
      if (value && typeof value === 'object') {
        deepFreeze(value);
      }
    }
  }

  return Object.freeze(obj) as DeepReadonly<T>;
}
